import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledHero = styled.div`
  background: ${color('purple_050')};
  padding: ${spacing('xl4')} ${spacing('xl3')} 0 ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    margin-bottom: ${spacing('xl4')};
  }
`;

export const StyledWrapper = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  position: relative;
  padding-bottom: ${spacing('xl4')};
  padding-top: ${spacing('xl4')};
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #52105e;
  line-height: 1.5;
  gap: ${spacing('xl')};

  > div {
    width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  @media (min-width: ${screen('md')}) {
    text-align: left;
  }

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    gap: ${spacing('xl3')};

    > div {
      width: 50%;
    }
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;

  @media (min-width: ${screen('lg')}) {
    padding-left: ${spacing('xl5')};
  }
`;

export const StyledWarning = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing('xs2')};
  background-color: ${color('white')};
  color: ${color('text_default')};
  font-size: ${fontSize('sm')};
  line-height: 1.143;
  padding: ${spacing('xs')};
  border-radius: ${radius('md')};
  font-weight: ${fontWeight('medium')};
  text-align: left;

  svg {
    color: ${color('info_500')};
  }
`;

export const StyledIrregularBox = styled.div<{
  $src: string;
  $width?: string;
  $height?: string;
}>`
  background-image: ${({ $src }) => `url(${$src})`};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? 'auto'};
  max-width: 616px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('md')};
  padding: ${spacing('xl')};
  position: relative;

  @media (min-width: ${screen('md')}) and (max-width: ${screen('lg')}) {
    max-width: 100%;
    padding: ${spacing('xl')};
    flex-direction: row;
  }

  @media (min-width: ${screen('lg')}) {
    > :nth-child(1) {
      margin-left: -15%;
    }
    > :nth-child(2) {
      margin-left: 20%;
    }
  }
`;

export const StyledCardsBoxContainer = styled.div`
  display: flex;
  justify-content: center;
`;
